import { useEffect, useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import callAPI from '../../../../helpers/callAPI'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import CampaignSearch from '../../../../components/CampaignSearch/CampaignSearch'
import { useHistory } from 'react-router-dom'
import AffiliateSearch from '../../../../components/AffiliateSearch/AffiliateSearch'

const JobsModal = ({ showSystemMessage, jobId, setJobId, setJobIsOpen, handleClose }) => {
    const history = useHistory()
    const [formData, setFormData] = useState({
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        name: 'TEST',
        campaign: null,
        affiliate: {},
        param1: '',
        param2: '',
        param3: '',
        param4: '',
        param5: '',
        param6: '',
        param7: '',
        param8: '',
        status: 'P',
    })

    const [dataLoaded, setDataLoaded] = useState(false)
    const [campaign, setCampaign] = useState({})

    let isCreate = jobId === 0

    useEffect(() => {
        if (isCreate) {
            setDataLoaded(true)
            return
        }
        getJobInfo()
    }, [jobId])


    const getJobInfo = async () => {
        setDataLoaded(false)

        let url = `admin/job/${jobId}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setFormData({
                        date: new Date(moment(result.job.job_date).utc().format('YYYY-MM-DD HH:mm:ss')),
                        name: result.job.job_name,
                        campaign: {
                            id: result.job.offer_id,
                            name: result.job.offer_name,
                        },
                        affiliate: {
                            id: result.job.affiliate_id,
                            name: result.job.affiliate_name,
                        },
                        param1: result.job.param1,
                        param2: result.job.param2,
                        param3: result.job.param3,
                        param4: result.job.param4,
                        param5: result.job.param5 != null ? result.job.param5 : '',
                        param6: result.job.param6 != null ? result.job.param6 : '',
                        param7: result.job.param7 != null ? result.job.param7 : '',
                        param8: result.job.param8 != null ? result.job.param8 : '',
                        status: result.job.job_status,
                    })
                    setDataLoaded(true)
                } else {
                    showSystemMessage('error', result.errors.message)
                    setDataLoaded(true)
                }
            })
            .catch((err) => {
                console.log(`Error fetching job info: ${err}`)
                showSystemMessage('error', 'Error fetching job info')
                setDataLoaded(true)
            })
    }

    //     if (!isCreate && dataLoaded && data.jobs?.length > 0) {
    //         const jobIndex = data.jobs.findIndex((job) => parseInt(job.job_id) === parseInt(jobId))
    //         if (data.jobs[jobIndex] || data.jobs[0].job_id === jobId) {
    //             setFormData({
    //                 date: new Date(moment(data.jobs[jobIndex].job_date).utc().format('YYYY-MM-DD HH:mm:ss')),
    //                 name: data.jobs[jobIndex].job_name,
    //                 campaign: {
    //                     id: data.jobs[jobIndex].offer_id,
    //                     name: data.jobs[jobIndex].offer_name,
    //                 },
    //                 affiliate: {
    //                     id: data.jobs[jobIndex].affiliate_id,
    //                     name: data.jobs[jobIndex].affiliate_name,
    //                 },
    //                 param1: data.jobs[jobIndex].param1,
    //                 param2: data.jobs[jobIndex].param2,
    //                 param3: data.jobs[jobIndex].param3,
    //                 param4: data.jobs[jobIndex].param4,
    //                 param5: data.jobs[jobIndex].param5 != null ? data.jobs[jobIndex].param5 : '',
    //                 param6: data.jobs[jobIndex].param6 != null ? data.jobs[jobIndex].param6 : '',
    //                 param7: data.jobs[jobIndex].param7 != null ? data.jobs[jobIndex].param7 : '',
    //                 param8: data.jobs[jobIndex].param8 != null ? data.jobs[jobIndex].param8 : '',
    //                 status: data.jobs[jobIndex].job_status,
    //             })
    //         }
    //     }
    // }, [data, dataLoaded])

    useEffect(() => {
        if (campaign.id) {
            setFormData({ ...formData, campaign: campaign })
        }
    }, [campaign])

    const validate = () => {
        let isValidForm = true
        if (formData.name === '') {
            showSystemMessage('error', 'Job name is required')
            isValidForm = false
            return isValidForm
        } else if (formData.date === '') {
            showSystemMessage('error', 'Date is required')
            isValidForm = false
        }
        return isValidForm
    }
    const createJob = async () => {
        if (validate()) {
            const result = await callAPI(`admin/job`, 'POST', { ...formData })
            if (result.success) {
                showSystemMessage('success', 'Job created successfully')
                setJobId(0)
                handleClose(true)
            } else {
                showSystemMessage('error', result.errors.message)
            }
        }
    }

    const editJob = async () => {
        if (validate()) {
            const result = await callAPI(`admin/job/${jobId}`, 'PUT', { ...formData })
            if (result.success) {
                showSystemMessage('success', 'Job updated successfully')
                setJobId(0)
                handleClose(true)
            } else {
                showSystemMessage('error', result.errors.message)
            }
        }
    }
    return (
        <Card>
            <Card.Header closeButton>{isCreate ? 'Create Job' : 'Edit Job'}</Card.Header>
            {dataLoaded && (
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Job Name: </span>
                        <div className="w-75">
                            <Form.Control as="select" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })}>
                                <option value="TEST">Test Job</option>
                                <option value="RATE">Change Campaign Rate</option>
                                <option value="PUBRATE">Change Pub Rate</option>
                                <option value="CANCEL">Cancel Campaign</option>
                                <option value="RELAUNCH">Relaunch Campaign</option>
                                <option value="RATE_SCH">Schedule Rate Change</option>
                                <option value="PUBPULL">Remove Pub from Campaign</option>
                                <option value="MERPULL">Remove Pub from Merchant</option>
                            </Form.Control>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Campaign: </span>
                        <div className="w-75">
                            <CampaignSearch setCampaign={setCampaign} campaign={formData.campaign} order={2} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Affiliate: </span>
                        <div className="w-75">
                            <AffiliateSearch setFormData={setFormData} affiliate={formData.affiliate.id ? formData.affiliate : false} order={1} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Scheduled Date/Time: </span>
                        <div className="w-75">
                            <DatePicker placeholderText="Scheduled Date" className="form-control form-control" selected={moment(formData.date).toDate()} showTimeSelect onChange={(date) => setFormData({ ...formData, date: moment(date).format('YYYY-MM-DD HH:mm:ss') })} dateFormat="yyyy/MM/dd HH:mm:ss" />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 1: </span>
                        <div className="w-75">
                            <Form.Control type="text" value={formData.param1} onChange={(e) => setFormData({ ...formData, param1: e.target.value })} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 2: </span>
                        <div className="w-75">
                            <Form.Control type="text" value={formData.param2} onChange={(e) => setFormData({ ...formData, param2: e.target.value })} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 3: </span>
                        <div className="w-75">
                            <Form.Control type="text" value={formData.param3} onChange={(e) => setFormData({ ...formData, param3: e.target.value })} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 4: </span>
                        <div className="w-75">
                            <Form.Control type="text" value={formData.param4} onChange={(e) => setFormData({ ...formData, param4: e.target.value })} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 5 (rate name for RATE_SCH): </span>
                        <div className="w-75">
                            <Form.Control type="text" value={formData.param5} onChange={(e) => setFormData({ ...formData, param5: e.target.value })} />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 6 (new rate type for RATE_SCH): </span>
                        <div className="w-75">
                            <Form.Control as="select" value={formData.param6} onChange={(e) => setFormData({ ...formData, param6: e.target.value })}>
                                <option value=""></option>
                                <option value="F">$ per lead</option>
                                <option value="P">% of sale</option>
                            </Form.Control>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 7 (new display rate type for RATE_SCH): </span>
                        <div className="w-75">
                            <Form.Control as="select" value={formData.param7} onChange={(e) => setFormData({ ...formData, param7: e.target.value })}>
                                <option value=""></option>
                                <option value="F">$ per lead</option>
                                <option value="P">% of sale</option>
                            </Form.Control>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                        <span>Parameter 8 (new description for RATE_SCH): </span>
                        <div className="w-75">
                            <Form.Control type="text" value={formData.param8} onChange={(e) => setFormData({ ...formData, param8: e.target.value })} />
                        </div>
                    </div>
                </Card.Body>
            )}
            {isCreate ? (
                <Card.Footer className="d-flex justify-content-end">
                    <Button variant="primary" onClick={createJob} size="sm">
                        Create
                    </Button>
                </Card.Footer>
            ) : (
                <Card.Footer className="d-flex justify-content-end">
                    <Button variant="primary" onClick={editJob} size="sm">
                        Save
                    </Button>
                </Card.Footer>
            )}
        </Card>
    )
}

export default JobsModal
